
import Swal, {SweetAlertOptions, SweetAlertResult} from 'sweetalert2'

// interface IProps {
//     title: string,
//     body: string,
//     success: boolean,
//     isOpen: boolean
//   }

const ShowNotification = (
  title: string, 
  body: string, 
  icon: string, 
  callback = ( result: SweetAlertResult ) => { 
    return result 
  }) => {
    return Swal.fire({
        title: title,
        html: body,
        icon: icon,
        showCancelButton: false,
        confirmButtonColor: '#cf102d',
        cancelButtonColor: '#54565b',
        confirmButtonText: 'Aceptar'
      } as SweetAlertOptions)
    }
    
export default ShowNotification;